export const faqs = [
  {
    id: 'faq1',
    question: '什么是黑料网永久域名？',
    answer: '黑料网永久域名是我们为用户提供的稳定访问入口地址集合。由于网络环境的复杂性，网站域名可能会不定期更换，我们通过汇总和持续更新所有可用域名，确保用户随时都能找到最新的访问入口，不会因为单一域名失效而无法访问黑料网。',
  },
  {
    id: 'faq2',
    question: '为什么黑料网需要更换域名？',
    answer: '由于互联网环境的复杂性，部分网络服务提供商可能会对某些域名进行限制或封锁。为了保障用户始终能够正常访问，黑料网会定期更新和扩充可用域名列表，确保在任何网络环境下用户都能找到可用的访问地址。',
  },
  {
    id: 'faq3',
    question: '如何确保获取的是官方最新域名？',
    answer: '建议您将本页面（黑料网永久域名官方入口）加入浏览器收藏夹。我们的团队会24小时监控所有域名的可用性，一旦发现某个域名失效，会立即更新列表并提供新的可用域名。您只需访问本页面，即可获取最新、最权威的域名信息。',
  },
  {
    id: 'faq4',
    question: '多个域名之间有什么区别？',
    answer: '我们提供的多个域名在功能上完全一致，都指向同一个网站。不同的域名主要是为了应对不同网络环境下的访问需求。主域名是最常用的访问地址，备用域名在主域名不可用时自动切换，镜像域名提供全球加速，国内域名优化了国内用户的访问速度。',
  },
  {
    id: 'faq5',
    question: '如果所有域名都无法访问怎么办？',
    answer: '我们提供了多种联系渠道，如果遇到所有域名都无法访问的极端情况，您可以通过以下方式获取最新信息：1）发送邮件至我们的官方邮箱获取最新域名；2）关注我们的社交媒体账号获取实时更新；3）联系在线客服获取一对一帮助。我们会确保您始终能够找到可用的访问方式。',
  },
  {
    id: 'faq6',
    question: '收藏本站后还需要担心域名失效吗？',
    answer: '不需要。本页面（黑料网永久域名官方入口）是我们特别设置的稳定站点，不会轻易更换。即使黑料网主站的域名发生变化，本页面的地址也会保持稳定。您只需要收藏本页面，即可随时获取最新、最全的黑料网域名信息，彻底告别找不到入口的烦恼。',
  },
];